import { useParams } from "react-router-dom";
import {
  COLLECTION_SLUGS,
  CONTENT_TYPES,
} from "../features/explore/exploreSections";
import { getContentTypeFromSlug } from "../utils/utils";
import Explore from "../features/explore/Explore";
import ExploreActivity from "../features/explore/ExploreActivity";
import ExploreCollectionPage from "../features/explore/ExploreCollections";
import NotFoundPage from "./NotFoundPage";

/**
 * Single router entry point for everything under /explore.
 *
 * Content-type filters appear in the URL as slugs (movies|tv|books) and are
 * converted back to their enum value before being handed to a page.
 *
 * /explore                             → Explore (all types)
 * /explore/movies|tv|books             → Explore (filtered)
 * /explore/activity                    → ExploreActivity (all types)
 * /explore/activity/movies|tv|books    → ExploreActivity (filtered)
 * /explore/<collection-slug>           → ExploreCollectionPage (all types)
 * /explore/<collection-slug>/movies|…  → ExploreCollectionPage (filtered)
 * anything else                        → NotFoundPage
 *
 * Adding a new collection type only requires updating exploreSections.js.
 */
export default function ExploreDispatcher() {
  const { segment, contentType } = useParams();

  // /explore with no segment
  if (!segment) {
    return <Explore contentTypeFilter="all" />;
  }

  // /explore/movies|tv|books
  if (CONTENT_TYPES.has(segment)) {
    if (contentType) return <NotFoundPage />;
    return <Explore contentTypeFilter={getContentTypeFromSlug(segment)} />;
  }

  // /explore/activity[/contentType]
  if (segment === "activity") {
    if (contentType && !CONTENT_TYPES.has(contentType)) return <NotFoundPage />;
    return (
      <ExploreActivity
        contentTypeFilter={
          contentType ? getContentTypeFromSlug(contentType) : "all"
        }
      />
    );
  }

  // /explore/<collection-slug>[/contentType]
  if (COLLECTION_SLUGS.has(segment)) {
    if (contentType && !CONTENT_TYPES.has(contentType)) return <NotFoundPage />;
    return (
      <ExploreCollectionPage
        collectionType={segment}
        contentTypeFilter={
          contentType ? getContentTypeFromSlug(contentType) : "all"
        }
      />
    );
  }

  return <NotFoundPage />;
}
